import ScanSearch from '../../components/ScanSearch'
import Icon from '../../components/Icon'
import * as productosApi from '../../api/productos'

const nf = (n) => Math.round(Number(n) || 0).toLocaleString('es-PY')

// ③ Servicios — barra de carga POS + tabla con inputs inline.
export default function DetalleServicios({ vm }) {
  const lineas = vm.servicios.filter((d) => d.servicio)

  const renderResult = (it) => (
    <>
      <div><div className="r-name">{it.descripcion}</div></div>
      <span className="r-price">{nf(it.precioVenta || 0)}</span>
    </>
  )

  return (
    <>
      <ScanSearch
        placeholder="Buscá un servicio por descripción…"
        fetcher={(s) => productosApi.buscarServicios(s)}
        onSelect={(s) => vm.addServicioConDatos(s)}
        renderResult={renderResult}
        minChars={2}
      />

      {lineas.length === 0 ? (
        <div style={{ padding: '40px 24px', textAlign: 'center', color: 'var(--text-muted)' }}>
          <div style={{ fontSize: 13, marginBottom: 4 }}>Aún no agregaste servicios</div>
          <div style={{ fontSize: 12, color: 'var(--text-dim)' }}>Buscá arriba para empezar.</div>
        </div>
      ) : (
        <table className="products-table">
          <thead>
            <tr>
              <th style={{ width: 32 }}>#</th><th>Servicio</th>
              <th className="num" style={{ width: 110 }}>Cant.</th>
              <th className="num" style={{ width: 120 }}>Precio</th>
              <th className="num" style={{ width: 90 }}>Desc. %</th>
              <th className="num">IVA</th><th className="num">Subtotal</th><th style={{ width: 36 }} />
            </tr>
          </thead>
          <tbody>
            {vm.servicios.map((d, i) => d.servicio && (
              <tr key={i}>
                <td style={{ color: 'var(--text-dim)' }}>{lineas.indexOf(d) + 1}</td>
                <td className="item-name">{d.servicio.descripcion}</td>
                <td className="num">
                  <span className="qty-cell">
                    <button type="button" onClick={() => vm.updateServicio(i, { cantidad: Math.max(0, (Number(d.cantidad) || 0) - 1) })}>−</button>
                    <input value={d.cantidad} onChange={(e) => vm.updateServicio(i, { cantidad: e.target.value })} />
                    <button type="button" onClick={() => vm.updateServicio(i, { cantidad: (Number(d.cantidad) || 0) + 1 })}>+</button>
                  </span>
                </td>
                <td className="num"><input className="inline-input" value={d.precioVenta} onChange={(e) => vm.updateServicio(i, { precioVenta: e.target.value })} /></td>
                <td className="num"><input className="inline-input sm" value={d.descuento} onChange={(e) => vm.updateServicio(i, { descuento: e.target.value })} /></td>
                <td className="num" style={{ color: 'var(--text-muted)' }}>{d.montosImponibles?.[0]?.tipoImpuesto?.porcentaje ?? 0}%</td>
                <td className="num mono" style={{ fontWeight: 600 }}>{nf(d.totalItem)}</td>
                <td><span className="row-action" title="Quitar" onClick={() => vm.removeServicio(i)}><Icon name="trash" size={13} /></span></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  )
}
